{
  "app.name": "Cargofollow",
  "nav.dashboard.label": "Overzicht",
  "nav.shipments.label": "Zendingen",
  "nav.api_keys.label": "API-keys",
  "nav.webhooks.label": "Webhooks",
  "nav.events.label": "Gebeurtenissen",
  "nav.logs.label": "Logs",
  "nav.settings.label": "Instellingen",
  "nav.conformance.label": "Conformiteit",
  "nav.billing.label": "Facturatie",
  "nav.label": "Console-navigatie",
  "language.label": "Taal",
  "language.nl": "Nederlands",
  "language.en": "Engels",
  "language.de": "Duits",
  "loading": "Bezig met laden…",
  "button.retry": "Opnieuw proberen",
  "button.sign_out": "Uitloggen",
  "error.title": "Er ging iets mis",
  "error.body": "Probeer het opnieuw. Blijft het misgaan, neem dan contact met ons op.",
  "error.not_found.title": "Pagina niet gevonden",
  "error.not_found.body": "Deze pagina bestaat niet (meer).",
  "error.network": "Geen verbinding met de API.",
  "error.unexpected": "Onverwachte fout.",
  "login.title": "Inloggen",
  "login.intro": "Vul je e-mailadres in. Je krijgt een link waarmee je meteen binnen bent.",
  "login.email.label": "E-mailadres",
  "login.submit": "Stuur de inloglink",
  "login.sent.title": "Check je mail",
  "login.sent.body": "We hebben een inloglink gestuurd naar {email}. De link is 15 minuten geldig.",
  "login.to_signup": "Nog geen account? Maak er een aan.",
  "signup.title": "Account aanmaken",
  "signup.intro": "In één minuut een sandbox-key. Geen creditcard, geen verkoopgesprek.",
  "signup.name.label": "Je naam",
  "signup.organization.label": "Bedrijfsnaam",
  "signup.email.label": "Werk-e-mailadres",
  "signup.submit": "Account aanmaken",
  "signup.sent.title": "Nog één klik",
  "signup.sent.body": "We hebben een bevestigingslink gestuurd naar {email}. Open die link om je organisatie aan te maken.",
  "signup.to_login": "Heb je al een account? Log in.",
  "welcome.title": "Welkom bij Cargofollow",
  "welcome.intro": "Je organisatie {organization} staat klaar, met een sandbox-key.",
  "welcome.key.label": "Je sk_test_-key",
  "welcome.key.once": "Deze key wordt precies één keer getoond. Bewaar hem nu; daarna kun je alleen een nieuwe maken.",
  "welcome.key.copy": "Kopieer key",
  "welcome.key.copied": "Gekopieerd",
  "welcome.key.gone.title": "De key is al getoond",
  "welcome.key.gone.body": "Om veiligheidsredenen tonen we een key maar één keer. Maak een nieuwe key aan bij API-keys.",
  "welcome.quickstart.title": "Meteen proberen",
  "welcome.quickstart.body": "Maak je eerste zending met deze curl:",
  "welcome.continue": "Naar het overzicht",
  "live.title": "Live gaan",
  "live.body": "sk_live_-keys zet Cargofollow handmatig aan, nadat je de conformiteitschecklist hebt doorlopen. Tot die tijd werk je met sk_test_ in de sandbox.",
  "live.request": "Live aanvragen",
  "dashboard.title": "Overzicht",
  "dashboard.intro": "Hier komen je zendingen, keys, webhooks en logs te staan.",
  "email.magic_link.subject": "Je inloglink voor Cargofollow",
  "email.magic_link.body": "Klik op deze link om in te loggen bij de Cargofollow-console: {url}",
  "email.magic_link.ignore": "Heb je dit niet aangevraagd? Dan kun je deze mail negeren.",
  "login.error.unknown_email": "Er bestaat geen account voor dit adres, of je uitnodiging is verlopen. Maak een account aan.",
  "settings.title": "Instellingen",
  "settings.nav.members": "Leden",
  "members.title": "Leden",
  "members.intro": "Wie mag wat in deze organisatie. Rollen bepalen alleen wat je in de console ziet en mag; wat een API-key mag, staat in de scopes van die key.",
  "members.column.member": "Lid",
  "members.column.role": "Rol",
  "members.column.actions": "Acties",
  "members.you": "jij",
  "members.empty": "Er zijn nog geen andere leden.",
  "members.role.label": "Rol van {name}",
  "members.role.owner": "Eigenaar",
  "members.role.admin": "Beheerder",
  "members.role.developer": "Ontwikkelaar",
  "members.role.viewer": "Meekijker",
  "members.role.owner.hint": "Alles, inclusief de organisatie verwijderen en het eigendom overdragen.",
  "members.role.admin.hint": "Alles behalve de organisatie verwijderen en eigenaren wisselen.",
  "members.role.developer.hint": "Keys, webhooks en zendingen lezen en schrijven; geen leden.",
  "members.role.viewer.hint": "Alleen lezen.",
  "members.remove": "Verwijderen",
  "members.remove.confirm": "{name} uit deze organisatie verwijderen?",
  "members.last_owner": "De laatste eigenaar kan niet worden verwijderd of gedegradeerd.",
  "members.forbidden.title": "Geen toegang tot leden",
  "members.forbidden.body": "Je rol mag de ledenlijst niet bekijken. Vraag een beheerder om toegang.",
  "invite.title": "Collega uitnodigen",
  "invite.email.label": "E-mailadres",
  "invite.role.label": "Rol",
  "invite.submit": "Uitnodiging sturen",
  "invite.sent": "Uitnodiging gestuurd naar {email}.",
  "invitations.title": "Openstaande uitnodigingen",
  "invitations.empty": "Geen openstaande uitnodigingen.",
  "invitations.expires": "Verloopt {expires}",
  "invitations.revoke": "Intrekken",
  "accept.title": "Je bent uitgenodigd",
  "accept.intro": "{organization} nodigt je uit als {role}. We sturen een inloglink naar {email}; daarmee word je meteen lid.",
  "accept.submit": "Accepteren en inloggen",
  "accept.sent.title": "Check je mail",
  "accept.sent.body": "We hebben een inloglink gestuurd naar {email}. Open die link om lid te worden.",
  "accept.invalid.title": "Deze uitnodiging is niet meer geldig",
  "accept.invalid.body": "De uitnodiging is ingetrokken, verlopen of al gebruikt. Vraag je collega om een nieuwe.",
  "api_keys.new": "Nieuwe key",
  "api_keys.new.hint": "Maak een nieuwe key aan. De sleutel zelf zie je precies één keer.",
  "button.cancel": "Annuleren",
  "button.copy": "Kopiëren",
  "button.copied": "Gekopieerd",
  "mode.label": "Modus",
  "mode.test": "Test",
  "mode.live": "Live",
  "mode.live.disabled": "Live staat nog uit voor deze organisatie.",
  "api_keys.intro": "Keys authenticeren je API-aanroepen. Een key hoort bij één modus: sk_test_ raakt de sandbox, sk_live_ de echte wereld.",
  "api_keys.column.name": "Naam",
  "api_keys.column.prefix": "Key",
  "api_keys.column.scopes": "Scopes",
  "api_keys.column.created_by": "Aangemaakt door",
  "api_keys.column.last_used": "Laatst gebruikt",
  "api_keys.column.actions": "Acties",
  "api_keys.status.revoked": "Ingetrokken",
  "api_keys.never_used": "Nog niet gebruikt",
  "api_keys.unknown_creator": "Bij aanmelding",
  "api_keys.empty": "Er zijn nog geen keys in deze modus.",
  "api_keys.revoke": "Intrekken",
  "api_keys.revoke.confirm": "Key {name} intrekken? Aanroepen met deze key falen meteen.",
  "api_keys.form.title": "Nieuwe key",
  "api_keys.form.name": "Naam",
  "api_keys.form.name.hint": "Waar gebruik je hem voor? Bijvoorbeeld: backend productie.",
  "api_keys.form.mode": "Modus",
  "api_keys.form.scopes": "Scopes",
  "api_keys.form.submit": "Key aanmaken",
  "api_keys.created.title": "Je nieuwe key",
  "api_keys.created.once": "Deze key wordt precies één keer getoond. Bewaar hem nu; daarna zie je alleen nog de prefix.",
  "api_keys.created.done": "Ik heb hem bewaard",
  "api_keys.live.blocked": "Live-keys zet Cargofollow handmatig aan, na de conformiteitschecklist. Vraag live-toegang aan; we nemen contact met je op.",
  "live.request.sent": "Je aanvraag is verstuurd. We nemen contact op via {email}.",
  "live.request.note": "Toelichting (optioneel)",
  "conformance.intro": "Voordat je live mag, willen we zien dat je integratie ook aankan wat er in productie misgaat. Deze twaalf scenario's leest de checklist terug uit je eigen gebeurtenissen, logs en webhook-leveringen in test-mode.",
  "conformance.progress": "{passed} van {total} scenario's aangetoond",
  "conformance.checked": "Laatst gecontroleerd op {moment}",
  "conformance.never_checked": "Nog niet gecontroleerd",
  "conformance.recheck": "Nu controleren",
  "conformance.ready.title": "Klaar voor live",
  "conformance.ready.body": "Alle scenario's zijn aangetoond. Vraag live aan; Cargofollow zet sk_live_-keys daarna handmatig aan.",
  "conformance.blocked": "Live aanvragen kan zodra alle twaalf scenario's zijn aangetoond.",
  "conformance.blocked.title": "Nog niet klaar voor live",
  "conformance.requested": "Live aangevraagd op {moment}.",
  "conformance.enabled.title": "Je organisatie is al live",
  "conformance.enabled.body": "sk_live_-keys staan aan. De checklist blijft staan als naslag van wat je in de sandbox hebt aangetoond.",
  "conformance.table.caption": "Conformance-scenario's",
  "conformance.column.status": "Status",
  "conformance.column.scenario": "Scenario",
  "conformance.column.moment": "Aangetoond",
  "conformance.status.passed": "Aangetoond",
  "conformance.status.pending": "Nog niet aangetoond",
  "conformance.status.failed": "Mislukt",
  "conformance.hint": "Hoe toon je dit aan?",
  "conformance.scenario.create_shipment.title": "Zending aanmaken",
  "conformance.scenario.create_shipment.body": "Je hebt een zending aangemaakt met POST /v1/shipments.",
  "conformance.scenario.validate_with_error_handled.title": "Een fout afgehandeld",
  "conformance.scenario.validate_with_error_handled.body": "Je kreeg een 422 op een ongeldige body en maakte daarna alsnog een zending aan.",
  "conformance.scenario.issue.title": "Uitgeven",
  "conformance.scenario.issue.body": "Je hebt een zending uitgegeven, waarmee versie 1 van de vrachtbrief is vastgelegd.",
  "conformance.scenario.signature_via_link.title": "Tekenen via een link",
  "conformance.scenario.signature_via_link.body": "Er is getekend via een tekenlink, zonder API-key.",
  "conformance.scenario.delivery_with_pod.title": "Afleveren met ePOD",
  "conformance.scenario.delivery_with_pod.body": "Je hebt een zending afgeleverd en het afleverbewijs teruggelezen.",
  "conformance.scenario.webhook_endpoint_configured.title": "Webhook-endpoint ingesteld",
  "conformance.scenario.webhook_endpoint_configured.body": "Je hebt een endpoint aangemeld waar gebeurtenissen naartoe gaan.",
  "conformance.scenario.webhook_echo_verified.title": "Echo-header bevestigd",
  "conformance.scenario.webhook_echo_verified.body": "Je ontvanger beantwoordde een ping met dezelfde freightapi-echo-header die wij meestuurden.",
  "conformance.scenario.webhook_delivery_succeeded.title": "Levering geslaagd",
  "conformance.scenario.webhook_delivery_succeeded.body": "Een echte gebeurtenis is door je ontvanger met een 2xx geaccepteerd.",
  "conformance.scenario.idempotency_key_used.title": "Idempotency-Key gebruikt",
  "conformance.scenario.idempotency_key_used.body": "Je stuurde een POST met een Idempotency-Key, zodat een herhaalde aanroep geen tweede zending oplevert.",
  "conformance.scenario.integrity_checked.title": "Hash-keten gecontroleerd",
  "conformance.scenario.integrity_checked.body": "Je hebt het integriteitsrapport van een zending opgevraagd.",
  "conformance.scenario.pdf_downloaded.title": "PDF gedownload",
  "conformance.scenario.pdf_downloaded.body": "Je hebt de vrachtbrief als PDF opgehaald.",
  "conformance.scenario.auto_sandbox_run.title": "Sandbox-run met auto",
  "conformance.scenario.auto_sandbox_run.body": "Je hebt een sandbox-zending de hele levenscyclus laten doorlopen met action: auto.",
  "webhooks.intro": "Webhook-endpoints ontvangen events van Cargofollow. Elke bezorging is ondertekend met het secret van het endpoint.",
  "webhooks.column.url": "URL",
  "webhooks.column.events": "Events",
  "webhooks.column.status": "Status",
  "webhooks.column.actions": "Acties",
  "webhooks.status.active": "Actief",
  "webhooks.status.inactive": "Inactief",
  "webhooks.empty": "Er zijn nog geen endpoints in deze modus.",
  "webhooks.new": "Nieuw endpoint",
  "webhooks.form.title": "Nieuw endpoint",
  "webhooks.form.url": "URL",
  "webhooks.form.events": "Events",
  "webhooks.form.events.hint": "Komma-gescheiden: shipment.*, signature.completed, of * voor alles.",
  "webhooks.form.description": "Omschrijving",
  "webhooks.form.submit": "Endpoint aanmaken",
  "webhooks.secret.title": "Het secret van dit endpoint",
  "webhooks.secret.once": "Dit secret wordt precies één keer getoond. Bewaar het; daarmee controleer je de handtekening van elke bezorging.",
  "webhooks.test": "Test sturen",
  "webhooks.test.result": "HTTP {status} in {duration} ms",
  "webhooks.test.failed": "Mislukt na {duration} ms: {error}",
  "webhooks.pause": "Pauzeren",
  "webhooks.activate": "Activeren",
  "webhooks.delete": "Verwijderen",
  "webhooks.delete.confirm": "Endpoint {url} verwijderen? Bezorgingen stoppen meteen.",
  "settings.nav.organization": "Organisatie",
  "organization.title": "Organisatie",
  "organization.intro": "De naam die op documenten staat, de provider die een zending uitvoert en hoe lang we data bewaren.",
  "organization.name.label": "Naam",
  "organization.default_provider.label": "Standaardprovider",
  "organization.default_provider.hint": "De provider die een zending krijgt als de aanroep er geen noemt.",
  "organization.providers.label": "Toegestane providers",
  "organization.providers.hint": "Alleen deze providers mag een zending kiezen.",
  "organization.retention.label": "Bewaartermijn (dagen)",
  "organization.retention.hint": "Tussen 30 en 3650 dagen.",
  "organization.save": "Opslaan",
  "organization.saved": "Instellingen opgeslagen.",
  "shipments.intro": "Alle zendingen in deze modus, nieuwste eerst.",
  "shipments.filter.status": "Status",
  "shipments.filter.status.any": "Alle statussen",
  "shipments.filter.reference": "Referentie",
  "shipments.filter.provider": "Provider",
  "shipments.filter.provider.any": "Alle providers",
  "shipments.filter.created_after": "Aangemaakt vanaf",
  "shipments.filter.created_before": "Aangemaakt tot en met",
  "shipments.filter.apply": "Filteren",
  "shipments.filter.reset": "Wissen",
  "shipments.column.reference": "Referentie",
  "shipments.column.status": "Status",
  "shipments.column.route": "Route",
  "shipments.column.provider": "Provider",
  "shipments.column.created": "Aangemaakt",
  "shipments.version": "Versie {version}",
  "shipments.empty.title": "Geen zendingen",
  "shipments.empty.body": "Er is geen zending die aan deze filters voldoet. Maak er een met de API, of pas de filters aan.",
  "shipments.page.previous": "Vorige",
  "shipments.page.next": "Volgende",
  "shipments.detail.back": "Terug naar zendingen",
  "shipments.detail.created": "Aangemaakt op {timestamp}",
  "shipments.tabs.label": "Tabbladen van deze zending",
  "shipments.tab.overview": "Overzicht",
  "shipments.tab.timeline": "Tijdlijn",
  "shipments.tab.documents": "Documenten",
  "shipments.tab.signatures": "Handtekeningen",
  "shipments.tab.pod": "POD",
  "shipments.tab.provider": "Provider",
  "shipments.tab.webhooks": "Webhooks",
  "shipments.tab.raw": "Ruwe JSON",
  "shipments.tab.authorisations": "Autorisaties",
  "shipments.authorisations.title": "Autorisatieregister",
  "shipments.authorisations.intro": "Wie welke bewerking op deze eFTI-dataset mag uitvoeren, voor hoe lang en over welk deel van de gegevens (artikel 5 van Uitvoeringsverordening (EU) 2025/2243). Ingetrokken rechten blijven staan: het register moet net zo lang controleerbaar zijn als de dataset zelf.",
  "shipments.authorisations.dataset": "Dataset-UUID: {uuid}",
  "shipments.authorisations.dataset.none": "Nog geen eFTI-dataset; de rechten gelden zodra die er is.",
  "shipments.authorisations.column.party": "Partij",
  "shipments.authorisations.column.role": "Rol",
  "shipments.authorisations.column.operations": "Bewerkingen",
  "shipments.authorisations.column.window": "Geldig",
  "shipments.authorisations.column.status": "Status",
  "shipments.authorisations.column.actions": "Acties",
  "shipments.authorisations.scope.all": "Volledige gemeenschappelijke dataset",
  "shipments.authorisations.until.none": "onbepaald",
  "shipments.authorisations.baseline": "Niet intrekbaar",
  "shipments.authorisations.revoke": "Intrekken",
  "shipments.authorisations.revoke.confirm": "Dit recht intrekken? De regel blijft in het register staan, met het moment van intrekken erbij.",
  "shipments.authorisations.revoke.done": "Recht ingetrokken.",
  "shipments.authorisations.empty.title": "Geen register",
  "shipments.authorisations.empty.body": "Deze zending heeft geen autorisatieregister. Bestaat ze in deze modus?",
  "shipments.authorisations.grant.title": "Recht verlenen",
  "shipments.authorisations.grant.intro": "De bewerkingen volgen uit de rol. Een partij zonder Cargofollow-account noem je met een e-mailadres en krijgt altijd een einddatum.",
  "shipments.authorisations.grant.party_type": "Soort partij",
  "shipments.authorisations.grant.party_ref": "Id van de partij",
  "shipments.authorisations.grant.email": "E-mailadres",
  "shipments.authorisations.grant.role": "Rol",
  "shipments.authorisations.grant.valid_until": "Geldig tot",
  "shipments.authorisations.grant.valid_until.hint": "Verplicht voor een partij zonder account, en hoogstens 90 dagen.",
  "shipments.authorisations.grant.submit": "Verlenen",
  "shipments.authorisations.grant.done": "Recht verleend.",
  "shipments.authorisations.party_type.organization": "Organisatie",
  "shipments.authorisations.party_type.member": "Gebruiker",
  "shipments.authorisations.party_type.api_key": "API-sleutel",
  "shipments.authorisations.party_type.contact": "Contact zonder account",
  "shipments.authorisations.party_type.authority": "Autoriteit",
  "shipments.authorisations.role.data_holder": "Gegevenshouder",
  "shipments.authorisations.role.consignor": "Afzender",
  "shipments.authorisations.role.carrier": "Vervoerder",
  "shipments.authorisations.role.consignee": "Geadresseerde",
  "shipments.authorisations.role.authority": "Autoriteit",
  "shipments.authorisations.role.other": "Overig",
  "shipments.authorisations.status.active": "Actief",
  "shipments.authorisations.status.scheduled": "Gepland",
  "shipments.authorisations.status.expired": "Verlopen",
  "shipments.authorisations.status.revoked": "Ingetrokken",
  "shipments.authorisations.source.baseline": "Gegevenshouder",
  "shipments.authorisations.source.granted": "Verleend",
  "shipments.authorisations.source.derived": "Automatisch",
  "shipments.processing.title": "Verwerkingslogboek",
  "shipments.processing.intro": "Elke bewerking op deze dataset, nieuwste eerst, zoals artikel 9, lid 5 het vraagt. Weigeringen staan er ook in, en toegang door een autoriteit via een nationale eFTI-gate eveneens.",
  "shipments.processing.empty": "Nog geen bewerkingen vastgelegd.",
  "shipments.processing.column.moment": "Moment",
  "shipments.processing.column.operation": "Bewerking",
  "shipments.processing.column.party": "Partij",
  "shipments.processing.column.outcome": "Uitkomst",
  "shipments.processing.outcome.allowed": "Toegestaan",
  "shipments.processing.outcome.refused": "Geweigerd",
  "shipments.processing.operation.create": "Aanmaken",
  "shipments.processing.operation.edit": "Bewerken",
  "shipments.processing.operation.read": "Lezen",
  "shipments.processing.operation.download": "Downloaden",
  "shipments.processing.operation.consignor_signature": "Handtekening afzender",
  "shipments.processing.operation.carrier_signature": "Handtekening vervoerder",
  "shipments.processing.operation.consignee_signature": "Handtekening geadresseerde",
  "shipments.processing.operation.combined_transport_stamp": "Stempel gecombineerd vervoer",
  "shipments.processing.operation.archive": "Archiveren",
  "shipments.processing.operation.waste_documents_download": "Afvaldocumenten downloaden",
  "shipments.processing.operation.waste_carrier_confirmation": "Bevestiging afvalvervoerder",
  "shipments.not_found.title": "Zending niet gevonden",
  "shipments.not_found.body": "Deze zending bestaat niet in deze organisatie en modus. Staat ze misschien in de andere modus?",
  "shipments.more": "Meer laden",
  "shipments.integrity.ok": "Keten intact",
  "shipments.integrity.ok.detail": "{events} gebeurtenissen, ongebroken sinds het aanmaken.",
  "shipments.integrity.broken": "Keten gebroken",
  "shipments.integrity.broken.detail": "De keten klopt niet meer vanaf seq {seq}.",
  "shipments.integrity.gaps": "Ontbrekende volgnummers: {gaps}",
  "shipments.integrity.head": "Kophash",
  "shipments.integrity.verified_at": "Gecontroleerd op {timestamp}",
  "shipments.events.title": "Gebeurtenissen en hashes",
  "shipments.events.column.seq": "Seq",
  "shipments.events.column.event": "Gebeurtenis",
  "shipments.events.column.occurred": "Moment",
  "shipments.events.column.actor": "Actor",
  "shipments.events.column.hash": "Hash",
  "shipments.events.column.prev_hash": "Vorige hash",
  "shipments.trace.title": "API-aanroepen",
  "shipments.trace.intro": "De aanroepen die deze zending noemden, nieuwste eerst.",
  "shipments.trace.empty": "Geen aanroepen binnen de bewaartermijn van de logs.",
  "shipments.trace.column.call": "Aanroep",
  "shipments.trace.column.status": "Status",
  "shipments.trace.column.duration": "Duur",
  "shipments.trace.column.request_id": "Request-id",
  "shipments.trace.column.moment": "Moment",
  "shipments.signatures.empty": "Er is nog niet getekend.",
  "shipments.signatures.column.role": "Rol",
  "shipments.signatures.column.signer": "Ondertekenaar",
  "shipments.signatures.column.method": "Methode",
  "shipments.signatures.column.signed_at": "Getekend op",
  "shipments.signatures.column.hash": "Versiehash",
  "shipments.pod.empty.title": "Nog geen afleverbewijs",
  "shipments.pod.empty.body": "Het afleverbewijs verschijnt zodra de geadresseerde bij aflevering heeft getekend.",
  "shipments.pod.delivered_at": "Afgeleverd op",
  "shipments.pod.signed_by": "Getekend door",
  "shipments.pod.colli": "Colli",
  "shipments.pod.remarks": "Opmerkingen",
  "shipments.pod.remarks.empty": "Geen opmerkingen bij aflevering.",
  "shipments.pod.photos": "Foto's",
  "shipments.pod.pdf": "Afleverbewijs (PDF)",
  "shipments.pod.pdf.none": "Er staat nog geen PDF klaar.",
  "shipments.provider.empty.title": "Nog geen providerkoppeling",
  "shipments.provider.empty.body": "Een zending krijgt een koppeling zodra ze is uitgegeven en de synchronisatie heeft gedraaid.",
  "shipments.provider.provider": "Provider",
  "shipments.provider.status": "Synchronisatiestatus",
  "shipments.provider.external_id": "Externe id",
  "shipments.provider.last_operation": "Laatste bewerking",
  "shipments.provider.last_synced": "Laatst gesynchroniseerd",
  "shipments.provider.error": "Laatste fout",
  "shipments.provider.retry": "Opnieuw synchroniseren",
  "shipments.provider.retry.started": "De synchronisatie is opnieuw gestart. Ververs over een paar seconden.",
  "shipments.provider.status.pending": "In behandeling",
  "shipments.provider.status.synced": "Gesynchroniseerd",
  "shipments.provider.status.failed": "Mislukt",
  "shipments.provider.status.cancelled": "Geannuleerd",
  "shipments.provider.trace.title": "Trace",
  "shipments.provider.trace.empty": "De synchronisatie heeft nog geen stappen vastgelegd.",
  "shipments.provider.trace.column.step": "Stap",
  "shipments.provider.trace.column.outcome": "Resultaat",
  "shipments.provider.trace.column.detail": "Toelichting",
  "shipments.provider.trace.column.moment": "Moment",
  "shipments.provider.step.normalize": "Normaliseren",
  "shipments.provider.step.validate": "Valideren",
  "shipments.provider.step.select": "Provider kiezen",
  "shipments.provider.step.publish": "Publiceren",
  "shipments.provider.step.status": "Status ophalen",
  "shipments.provider.outcome.ok": "Gelukt",
  "shipments.provider.outcome.skipped": "Overgeslagen",
  "shipments.provider.outcome.failed": "Mislukt",
  "shipments.webhooks.empty": "Er zijn nog geen bezorgingen voor deze zending.",
  "shipments.webhooks.column.event": "Event",
  "shipments.webhooks.column.status": "Status",
  "shipments.webhooks.column.attempt": "Poging",
  "shipments.webhooks.column.response": "Antwoord",
  "shipments.webhooks.column.moment": "Moment",
  "shipments.webhooks.status.pending": "In wachtrij",
  "shipments.webhooks.status.succeeded": "Gelukt",
  "shipments.webhooks.status.failed": "Mislukt",
  "shipments.webhooks.status.dead": "Opgegeven",
  "shipments.raw.intro": "De huidige versie van deze zending, precies zoals de API haar teruggeeft.",
  "shipments.raw.copy": "JSON kopiëren",
  "shipments.raw.copied": "Gekopieerd",
  "button.close": "Sluiten",
  "filter.apply": "Filteren",
  "filter.reset": "Wissen",
  "page.previous": "Vorige",
  "page.next": "Volgende",
  "webhooks.nav.endpoints": "Endpoints",
  "webhooks.nav.deliveries": "Bezorgingen",
  "deliveries.intro": "Wat Cargofollow naar jouw endpoints stuurde, nieuwste eerst. Klik op een event voor de exacte inhoud, het antwoord en de tijdlijn van pogingen.",
  "deliveries.table.caption": "Webhook-bezorgingen",
  "deliveries.empty.title": "Nog geen bezorgingen",
  "deliveries.empty.body": "Zodra een endpoint op een event geabonneerd is, komt elke verzending hier te staan.",
  "deliveries.column.event": "Event",
  "deliveries.column.endpoint": "Endpoint",
  "deliveries.column.status": "Status",
  "deliveries.column.attempts": "Pogingen",
  "deliveries.column.response": "Laatste antwoord",
  "deliveries.column.moment": "Moment",
  "deliveries.status.pending": "In wachtrij",
  "deliveries.status.succeeded": "Gelukt",
  "deliveries.status.failed": "Mislukt",
  "deliveries.status.dead": "Opgegeven",
  "deliveries.attempts": "{attempt} van {max}",
  "deliveries.no_response": "Geen antwoord",
  "deliveries.filter.status": "Status",
  "deliveries.filter.status.any": "Alle statussen",
  "deliveries.filter.endpoint": "Endpoint",
  "deliveries.filter.endpoint.any": "Alle endpoints",
  "deliveries.filter.event": "Event",
  "deliveries.filter.event.any": "Alle events",
  "deliveries.detail.title": "Bezorging",
  "deliveries.detail.event_id": "Event-id",
  "deliveries.detail.timeline": "Tijdlijn van pogingen",
  "deliveries.detail.attempt": "Verzending {number} · {status}",
  "deliveries.detail.answered": "Antwoordde {status} in {duration} ms",
  "deliveries.detail.request_headers": "Request-headers",
  "deliveries.detail.request_body": "Verstuurde inhoud",
  "deliveries.detail.response_body": "Antwoord van de ontvanger",
  "deliveries.detail.none": "Niets vastgelegd.",
  "deliveries.replay": "Opnieuw versturen",
  "events.intro": "Elke gebeurtenis van elke zending in deze organisatie, nieuwste eerst. Dezelfde rijen die een integratie via GET /v1/events ophaalt.",
  "events.table.caption": "Gebeurtenissen",
  "events.empty.title": "Nog geen gebeurtenissen",
  "events.empty.body": "Zodra er een zending wordt aangemaakt, verschijnt de eerste gebeurtenis hier.",
  "events.column.type": "Gebeurtenis",
  "events.column.shipment": "Zending",
  "events.column.actor": "Door",
  "events.column.seq": "Volgnr.",
  "events.column.moment": "Moment",
  "events.filter.type": "Soort",
  "events.filter.type.any": "Alle soorten",
  "logs.intro": "Elke API-aanroep van deze organisatie, met status, duur en de foutcode van een mislukking. Nooit een body: het log bewaart geen inhoud.",
  "logs.table.caption": "API-aanroepen",
  "logs.empty.title": "Geen aanroepen gevonden",
  "logs.empty.body": "Binnen de bewaartermijn van het log staat geen aanroep die aan dit filter voldoet.",
  "logs.column.call": "Aanroep",
  "logs.column.status": "Status",
  "logs.column.duration": "Duur",
  "logs.column.error": "Foutcode",
  "logs.column.moment": "Moment",
  "logs.duration": "{ms} ms",
  "logs.filter.status": "Status",
  "logs.filter.path": "Pad",
  "logs.filter.path.hint": "Exact pad, zonder querystring.",
  "logs.filter.request_id": "Request-id",
  "logs.detail.title": "API-aanroep",
  "logs.detail.request_id": "Request-id",
  "logs.detail.no_body": "Het log bewaart samenvattingen, geen request- of response-bodies.",
  "logs.error.docs": "Wat betekent deze code?",
  "billing.intro": "Wat deze organisatie heeft verbruikt, op welk abonnement dat staat en welke facturen de facturatieprovider ervoor heeft. Test-mode wordt geteld en getoond, maar nooit in rekening gebracht.",
  "billing.plan.title": "Abonnement",
  "billing.plan.tier": "Tier",
  "billing.plan.status": "Status",
  "billing.plan.period_end": "Einde huidige periode",
  "billing.plan.period_end.none": "Nog geen periode bekend",
  "billing.tier.sandbox": "Sandbox",
  "billing.tier.starter": "Starter",
  "billing.tier.scale": "Scale",
  "billing.tier.enterprise": "Enterprise",
  "billing.status.active": "Betaald",
  "billing.status.past_due": "Betaling mislukt",
  "billing.status.canceled": "Opgezegd",
  "billing.unconfigured.title": "Facturatie staat uit in deze omgeving",
  "billing.unconfigured.body": "Er is geen facturatieprovider gekoppeld, dus er wordt niets in rekening gebracht en het klantportaal is niet beschikbaar. Het verbruik hieronder wordt wel gewoon bijgehouden.",
  "billing.usage.title": "Verbruik",
  "billing.usage.window": "{from} tot en met {to}",
  "billing.usage.test_mode": "Je kijkt naar test-mode. Sandbox is gratis zonder tijdslimiet; deze cijfers tellen niet mee voor de factuur.",
  "billing.usage.table.caption": "Verbruik per dag",
  "billing.usage.empty.title": "Nog geen verbruik geteld",
  "billing.usage.empty.body": "De nachtelijke telling heeft voor deze periode nog niets vastgelegd. Zodra er een zending wordt uitgegeven of een handtekening wordt gezet, verschijnt de eerste dag hier.",
  "billing.column.day": "Dag",
  "billing.column.shipments_issued": "Uitgegeven",
  "billing.column.signatures": "Handtekeningen",
  "billing.column.notifications": "Notificaties",
  "billing.column.documents": "Documenten",
  "billing.column.storage": "Opslag",
  "billing.totals.title": "Totaal in deze periode",
  "billing.totals.storage.hint": "Opslag is het niveau op de laatste dag, geen optelsom.",
  "billing.invoices.title": "Facturen",
  "billing.invoices.table.caption": "Facturen",
  "billing.invoices.column.number": "Nummer",
  "billing.invoices.column.status": "Status",
  "billing.invoices.column.amount": "Bedrag",
  "billing.invoices.column.period": "Periode tot",
  "billing.invoices.column.link": "Document",
  "billing.invoices.status.draft": "Concept",
  "billing.invoices.status.open": "Openstaand",
  "billing.invoices.status.paid": "Betaald",
  "billing.invoices.status.uncollectible": "Oninbaar",
  "billing.invoices.status.void": "Vervallen",
  "billing.invoices.empty.title": "Nog geen facturen",
  "billing.invoices.empty.body": "Zodra de eerste factuurperiode is afgesloten, staat de factuur hier en in het klantportaal.",
  "billing.invoices.open": "Bekijken",
  "billing.portal.title": "Klantportaal",
  "billing.portal.body": "Betaalgegevens wijzigen, facturen downloaden en het abonnement bekijken doe je bij de facturatieprovider.",
  "billing.portal.button": "Klantportaal openen",
  "billing.portal.unavailable": "Niet beschikbaar zolang er geen facturatieprovider is gekoppeld.",
  "billing.portal.failed": "Het klantportaal kon niet worden geopend. Probeer het later opnieuw.",
  "settings.nav.security": "Beveiliging",
  "security.title": "Tweefactorauthenticatie",
  "security.intro": "Een authenticator-app naast de inloglink. Voor zakelijke gebruikers van een eFTI-platform is een tweede factor verplicht (IR (EU) 2025/2243).",
  "security.enabled": "Tweefactorauthenticatie staat aan voor je account.",
  "security.disabled": "Je account heeft nog geen authenticator. Zonder tweede factor is de link in je mailbox de enige sleutel.",
  "security.enable": "Authenticator instellen",
  "security.disable": "Uitzetten",
  "security.regenerate": "Nieuwe herstelcodes",
  "security.recovery_remaining": "Nog {count} herstelcodes over.",
  "security.locked": "Deze organisatie vereist tweefactorauthenticatie; een eigenaar of beheerder moet die eis eerst opheffen.",
  "security.policy.title": "Voor de hele organisatie",
  "security.policy.intro": "Wie nog geen authenticator heeft, komt bij de eerstvolgende aanroep op het instelscherm terecht, niet voor een dichte deur.",
  "security.policy.label": "Verplicht tweefactorauthenticatie voor elk lid",
  "security.policy.hint": "Weer uitzetten laat bestaande authenticators staan.",
  "two_factor.setup.title": "Scan de QR-code",
  "two_factor.setup.intro": "Open je authenticator-app — 1Password, Bitwarden, Google Authenticator, Aegis — en scan deze code. Vul daarna de zes cijfers in die de app laat zien.",
  "two_factor.setup.manual": "Kan je telefoon niet scannen? Voer deze sleutel dan handmatig in.",
  "two_factor.setup.qr.label": "QR-code voor je authenticator-app",
  "two_factor.setup.submit": "Instellen afronden",
  "two_factor.code.label": "Code uit de app",
  "two_factor.code.hint": "Zes cijfers, dertig seconden geldig.",
  "two_factor.recovery.title": "Bewaar je herstelcodes",
  "two_factor.recovery.intro": "Elke code werkt één keer en vervangt de app als je je telefoon kwijt bent. We laten ze nu één keer zien en daarna nooit meer.",
  "two_factor.recovery.download": "Downloaden",
  "two_factor.recovery.acknowledge": "Ik heb ze bewaard",
  "two_factor.recovery.label": "Herstelcode",
  "two_factor.recovery.hint": "Een van de codes die je bij het instellen hebt bewaard.",
  "two_factor.prompt.title": "Bevestig dat jij het bent",
  "two_factor.prompt.body": "Vul de zes cijfers in die je authenticator-app nu laat zien.",
  "two_factor.prompt.recovery_body": "Vul een van je herstelcodes in. Elke code werkt precies één keer.",
  "two_factor.prompt.submit": "Doorgaan",
  "two_factor.prompt.use_recovery": "Telefoon niet bij de hand? Gebruik een herstelcode",
  "two_factor.prompt.use_totp": "Toch de code uit de app gebruiken",
  "two_factor.prompt.lost": "Alles kwijt? Een eigenaar of beheerder van je organisatie kan je tweede factor opnieuw instellen.",
  "two_factor.required.title": "Stel tweefactorauthenticatie in",
  "two_factor.required.body": "Deze organisatie vereist een tweede factor. Zolang je geen authenticator hebt, blijft de rest van de console dicht.",
  "two_factor.done.title": "Alles in orde",
  "two_factor.done.body": "Deze sessie is al bevestigd.",
  "two_factor.done.continue": "Naar de console",
  "two_factor.error.invalid": "Die code klopt niet, is verlopen of is al gebruikt.",
  "two_factor.error.required": "Deze pagina vraagt eerst om je tweede factor.",
  "two_factor.error.too_many": "Te veel pogingen. Probeer het over een paar minuten opnieuw.",
  "members.reset_two_factor": "2FA resetten",
  "members.reset_two_factor.confirm": "Tweefactorauthenticatie van {name} wissen? Diegene moet daarna zelf een nieuwe authenticator instellen."
}
